import { Grid, Typography } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

type GiftDetailViewProps = {
  label: string;
  children: React.ReactNode;
};

export const GiftDetailBox = (giftItem: GiftDetailViewProps) => {
  const { label, children } = giftItem;
  return (
    <GridWrapper narrow>
      <Grid item xs={12} sm={4}>
        {label && <Typography sx={{ fontWeight: 500 }}>{label}</Typography>}
      </Grid>
      <Grid item xs={12} sm={8}>
        {label && <Typography mb={1}>{children || '-'}</Typography>}
      </Grid>
    </GridWrapper>
  );
};
